<template>
  <div :show="show" @close="close">
    <div class="modal-body">
      <ul class="weekday-list">
        <template v-for="(d, index) in data">
          <li :class="weekdayOn(d.year, d.month, d.day)" :key="index">
            <button @click="dayClick(d.year, d.month, d.day)"><span class="week-text">{{ d.week }}</span><span class="date-text">{{ d.month + '/' + d.day }}</span></button>
          </li>
        </template>
      </ul>
    </div>
    <div class="modal-footer popup-close">
      <button class="modal-default-button" @click="$parent.$emit('close')">
        <img src="../../assets/images/ic-gnb-close-w.png" class="btn-close-popup" alt="팝업닫기"/>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    today: {
      type: String
    },
    show: {
      type: Boolean
    }
  },
  methods: {
    // 지정된 자리수만큼 0을 채워주는 함수
    pad (num, width) {
      var numStr = num + ''
      return numStr.length >= width ? numStr
        : new Array((width - numStr.length) + 1).join('0') + numStr
    },
    // 닫기
    close () {
      this.$parent.$emit('close')
    },
    // 현재 날짜
    weekdayOn (year, month, day) {
      let selectedDate = year + '-' + this.pad(month, 2) + '-' + this.pad(day, 2)
      if (this.today === selectedDate) {
        return 'weekday-on'
      }
      return ''
    },
    // 날짜 클릭
    dayClick (year, month, day) {
      this.$emit('dayClick', year, month, day)
      this.close()
    }
  }
}
</script>
<style scoped>
  .weekday-list {
    position: absolute;
    left: 16px;
    top: 100px;
  }
  .weekday-list li, .weekday-list li button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .weekday-list li {
    background-color: #1351f9;
    color: #fff;
    margin-bottom: 9px;
  }
  #open-week button {
    font-size: 10px;
    color: #fff;
    font-weight: 700;
  }
  .weekday-list li, .weekday-list li button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .week-text {
    display: block;
    font-size: 12px;
    line-height: 15px;
    font-weight: 700;
  }
  .date-text {
    display: block;
    font-size: 10px;
    line-height: 15px;
    font-weight: 400;
  }
  .weekday-list li.weekday-on .date-text, .weekday-list li.weekday-on .week-text {
    opacity: .3;
  }
  #open-week button {
    font-size: 10px;
    color: #fff;
    font-weight: 700;
  }
  button {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 0;
    border: none;
    background: transparent;
  }
  .modal-default-button {
    position: absolute;
    width: 36px;
    height: 36px;
    top: 0;
    right: 7px;
  }
  .btn-close-popup {
    width: 36px;
  }
</style>
